import { inputRadioVariant, type InputRadioVariantProps } from "./input-radio.variants";

export type UseInputRadioProps = InputRadioVariantProps &
  React.InputHTMLAttributes<HTMLInputElement> & {
    className?: string;
    label?: string;
    id: string;
  };

export const useInputRadio = (props: UseInputRadioProps) => {
  const { className = "", label, id, ...componentProps } = props;

  const styles = inputRadioVariant();

  return {
    className,
    styles,
    label,
    id,
    componentProps,
  };
};
